import {takeEvery,takeLatest, call, put, select } from 'redux-saga/effects'
import { toast } from 'react-toastify';
import { getApi, postApi, getApiWithParam } from '../../utils/ApiRequest';
import { useSelector, useDispatch } from 'react-redux'
import {
  SignInSuccess,
  SignInFailure,
  OTPSuccess,
  OTPFailure,
  ResetPasswordSuccess,
  ResetPasswordFailure,
  DeliveryListSuccess,
  DeliveryListFailure,
  AcceptRejectSuccess,
  AcceptRejectFailure,
  detailsdataFailure,
  detailsdataSuccess,
  getTokenSuccess,
  GetProfileSuccess,
  GetProfileFailure,
  StatusChangeSuccess,
  StatusChangeFailure,
  UpdateProfileSuccess,
  UpdateProfileFailure,
  ResendotpSuccess,
  ResendotpFailure,
  GetBankSuccess,
  GetBankFailure,
  GetEarningSuccess,
  GetEarningFailure,
  UpdateBankSuccess,
  UpdateBankFailure


} from '../reducer/FetchDataReducer';


var token = localStorage.getItem('access_token');


// function* get_tokensaga() {
//   console.log("get tokensaga")
//   try {
//     let response = yield call(localStorage.getItem, 'access_token');
//     // const response = localStorage.getItem('access_token');
//     console.log("get tokensaga response", response)
//     if (response != null) {
//       yield put(getTokenSuccess(response));
//     } else {
//       yield put(getTokenSuccess(null));
//     }
//   } catch (error) {
//     yield put(getTokenFailure(error));
//   }
// }


function* LoginRequest(action) {

    let header = {
        Accept: 'application/json',
        contenttype: 'application/json',
      };

      try {
        //let response = yield call(() => axios.post(`${Constant.BASE_URL}/login`, action, header));
        let response = yield call(postApi, 'login', action.payload.obj, header);
        if(response.data.status){
          if (response?.data?.data?.access_token != null) {
            localStorage.setItem('access_token', response.data?.data?.access_token)
            yield put(getTokenSuccess(response.data?.data?.access_token));
          }
          yield put(SignInSuccess(response.data))
          toast.success(response.data?.message);
          action.payload.navigate("/dashboard")
          window.location.reload();
        } else {
          yield put(SignInFailure(response.data))
          toast.error(response.data?.message);
        }
        

      } catch(err){
        console.log("saga",err)
      }

    
}

function* OTPRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
    };
    try {
      let response = yield call(postApi, 'forget-password', action.payload.obj, header);
      if(response.data.status){
        
        yield put(OTPSuccess(response.data.data))
        toast.success(response.data?.message);
        action.payload.navigate("/otp", {state:{user:action.payload.obj,otp:response.data.data}})
      } else {
        yield put(OTPFailure(response.data))
        toast.error(response.data?.message[0]);
      }
      

    } catch(err){
      console.log("saga",err)
    }

  
}

function* ResetPasswordRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
    };
    try {
      let response = yield call(postApi, 'reset-password', action.payload.obj, header);
      if(response.data.status){
        
        yield put(ResetPasswordSuccess(response.data.data))
        toast.success(response.data?.message);
        action.payload.navigate("/login")
      } else {
        yield put(ResetPasswordFailure(response.data))
        toast.error(response.data?.message[0]);
      }
      

    } catch(err){
      console.log("saga",err)
    }

  
}


function* GetProfileRequest() {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(getApi, 'agent/profile', header);
      if(response.data.status){
        yield put(GetProfileSuccess(response.data))
      
      } else {
        yield put(GetProfileFailure(response.data))
        // toast.error(response.data?.message);
        console.log('profile false')
      }
    } catch(err){
      yield put(GetProfileFailure(err.data))
      console.log("saga",err)
    }

  
}

function* UpdateProfileRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'multipart/form-data',
      accesstoken:token,
    };

    try {
      let response = yield call(postApi, 'agent/update-profile', action.payload, header);
      if(response.data.status){
        yield put(UpdateProfileSuccess(response.data))
        toast.success(response.data?.message)
      } else {
        yield put(UpdateProfileFailure(response.data))
        //toast.error(response.data?.message);
        console.log('profile false')
      }
    } catch(err){
      yield put(UpdateProfileFailure(err.data))
      console.log("saga",err)
    }

  
}

function* DeliveryListRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(getApi, `agent/deliveries/${action.payload.status}`, header);
      if(response.data.status){
        yield put(DeliveryListSuccess(response.data))
        console.log('deliveries', response.data.data)
      } else {
        yield put(DeliveryListFailure(response))
        // toast.error(response.data?.message);
        console.log('deliveries false')
      }
    } catch(err){
      yield put(DeliveryListFailure(err.response))
      if(err.response.status === 401){
      localStorage.clear();
      window.location.reload();
      }

    }

}

function* AcceptRejectRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken: token,
    };
    try {
      let response = yield call(postApi, 'agent/accept-or-reject', action.payload, header);
      if(response.data.status){
        yield put(AcceptRejectSuccess(response.data.data))
        toast.success(response.data?.message);
      } else {
        yield put(AcceptRejectFailure(response.data))
        //toast.error(response.data?.message[0]);
      }
      

    } catch(err){
      console.log("saga",err)
    }

  
}

function* DeliveryDetailsRequest(action) {


  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(getApi, `agent/delivery-details/${action.payload}`,  header);
      if(response.data.status){
        yield put(detailsdataSuccess(response.data))
        console.log('details', response.data.data)
      } else {
        yield put(detailsdataFailure(response.data))
        toast.error(response.data?.message);
      }
    } catch(err){
     
      console.log("saga",err)
    }

  
}

function* StatusChangeRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken: token,
    };
    try {
      let response = yield call(postApi, 'agent/change-delivery-status', action.payload, header);
      if(response.data.status){
        yield put(StatusChangeSuccess(response.data.data))
        toast.success(response.data?.message);
      } else {
        yield put(StatusChangeFailure(response.data))
        toast.error(response.data?.message);
      }
      

    } catch(err){
      console.log("saga",err)
    }

  
}

function* ResendotpRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken: token,
    };
    try {
      let response = yield call(postApi, 'agent/change-delivery-status', action.payload, header);
      if(response.data.status){
        yield put(ResendotpSuccess(response.data.data))
        toast.success(response.data?.message);
      } else {
        yield put(ResendotpFailure(response.data))
        toast.error(response.data?.message);
      }
      

    } catch(err){
      console.log("saga", err)
    }

  
}

function* GetBankRequest() {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(getApi, 'agent/get-bank-details', header);
      if(response.data.status){
        yield put(GetBankSuccess(response.data))
        console.log('bank', response.data.data)
      } else {
        yield put(GetBankFailure(response))
        // toast.error(response.data?.message);
        console.log('bank false')
      }
    } catch(err){
      yield put(GetBankFailure(err.data))
      console.log("saga",err)
    }

}

function* GetEarningRequest() {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(getApi, 'agent/earnings', header);
      if(response.data.status){
        yield put(GetEarningSuccess(response.data))
      } else {
        yield put(GetEarningFailure(response))
      }
    } catch(err){
      yield put(GetEarningFailure(err.data))
      console.log("saga",err)
    }

}

function* UpdateBankRequest(action) {

  let header = {
      Accept: 'application/json',
      contenttype: 'application/json',
      accesstoken:token,
    };

    try {
      let response = yield call(postApi, 'agent/update-bank-details', action.payload,  header);
      if(response.data.status){
        yield put(UpdateBankSuccess(response.data))
        toast.success(response.data?.message);
      } else {
        yield put(UpdateBankFailure(response))
       toast.error(response.data?.message);
        console.log('bank false')
      }
    } catch(err){
      yield put(UpdateBankFailure(err.data))
      console.log("saga",err)
    }

}




const watchFunction = [
  (function* () {
    yield takeLatest('FetchDataReducer/SignInRequest', LoginRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/OTPRequest', OTPRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/ResetPasswordRequest', ResetPasswordRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/DeliveryListRequest', DeliveryListRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/AcceptRejectRequest', AcceptRejectRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/DeliveryDetailsRequest', DeliveryDetailsRequest)
  })(),
  (function* () {
    yield takeLatest('FetchDataReducer/StatusChangeRequest', StatusChangeRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/GetProfileRequest', GetProfileRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/UpdateProfileRequest', UpdateProfileRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/ResendotpRequest', ResendotpRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/GetBankRequest', GetBankRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/GetEarningRequest', GetEarningRequest)
  })(),

  (function* () {
    yield takeLatest('FetchDataReducer/UpdateBankRequest', UpdateBankRequest)
  })(),
  
  
  
  
 
];
export default watchFunction;


